import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

const messages = defineMessages({
  standaloneHeader: {
    defaultMessage: 'Standalone Product Detail',
    description: 'productType.standaloneTitle',
    id: 'dG60KN',
  },
  standaloneTitle: {
    defaultMessage: 'Standalone',
    description: 'productType.standalone',
    id: 'zl1huM',
  },
  parentHeader: {
    defaultMessage: 'Parent Product Detail',
    description: 'productType.parentTitle',
    id: 'F2XJPC',
  },
  parentTitle: {
    defaultMessage: 'Parent',
    description: 'productType.parent',
    id: 'blJRWs',
  },
  variantHeader: {
    defaultMessage: 'Variant Product Detail',
    description: 'productType.variantTitle',
    id: 'NQT1O4',
  },
  variantTitle: {
    defaultMessage: 'Variant',
    description: 'productType.variant',
    id: 'miF0Er',
  },
});

export const ProductTypes = {
  Standalone: {
    productDetailHeaderText: <FormattedMessage {...messages.standaloneHeader} />,
    displayText: <FormattedMessage {...messages.standaloneTitle} />,
    name: 'Standalone',
  },
  Parent: {
    productDetailHeaderText: <FormattedMessage {...messages.parentHeader} />,
    displayText: <FormattedMessage {...messages.parentTitle} />,
    name: 'Parent',
  },
  Variant: {
    productDetailHeaderText: <FormattedMessage {...messages.variantHeader} />,
    displayText: <FormattedMessage {...messages.variantTitle} />,
    name: 'Variant',
  },
};
